import React, { useEffect, useState, useContext } from "react";
// import "./index.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { ThemeContext } from "../../providers/ThemeProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import { toast } from "react-toastify";
import axios from "../../axios";
import { API_CALL_URL_PRIVATE } from "../../constants/compensate";

import Texterror from "../Texterror";
import dragDark from "../../assets/img/drop-black.png";
import dragWhite from "../../assets/img/drop-white.png";
import { useSelector } from "react-redux";
import { CostCenterCategoryValidation } from "../../utils/validator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import calcIcon from "../../assets/img/calculator_hires.png";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

function AddCostCenterCategory() {
  const navigate = useNavigate();
  const [themeMode, setTheme] = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);
  const [TimezoneOptions, setTimezoneOptions] = useState([]);
  const [isInitialData, setISInitialData] = useState(true);
  const customer_code = useSelector((state) => state.compensate.customerCode);

  // workdriver
  const [formControl, setFormControl] = useState([]);
  const [visibleWorkDriverRows, setVisibleWorkDriverRows] = useState([]);
  const [hiddenWorkDriverRows, setHiddenWorkDriverRows] = useState([]);
  const [allZeroWorkDriver, setAllZeroWorkDriver] = useState(false);
  const [showAllWorkDriver, setShowAllWorkDriver] = useState(false);

  // trends
  const [trendsFormControl, setTrendsFormControl] = useState([]);
  const [visibleTrendsRows, setVisibleTrendsRows] = useState([]);
  const [hiddenTrendsRows, setHiddenTrendsRows] = useState([]);
  const [allZeroTrends, setAllZeroTrends] = useState(false);
  const [showAllTrends, setShowAllTrends] = useState(false);

  const [initialValues, setInitialValues] = useState({
    cost_center_category_id: "",
    cost_center_category: "",
    note: "",
    workdriver_graph_setting: [],
    trends_graph_setting: [],
  });

  const getInitalData = async () => {
    const resp = await axios.post(
      `${API_CALL_URL_PRIVATE}/costcentercategory/workdriver_graph_field_master`,
      { customer_code: parseInt(customer_code) }
    );
    console.log(resp);
    const Detail = resp?.data?.data?.category;
    const workDriverSettings = resp?.data?.data?.workdriver_graph;
    const trendsGraphSettings = resp?.data?.data?.trends_graph;
    setInitialValues((prev) => {
      return {
        ...prev,
        cost_center_category_id: Detail?.cost_center_category_id,
        cost_center_category: Detail?.cost_center_category,
        note: Detail?.note,
        workdriver_graph_setting: resp?.data?.data?.workdriver_graph,
        trends_graph_setting: resp?.data?.data?.trends_graph,
      };
    });

    // Workdriver graph settings
    if (workDriverSettings) {
      setFormControl(workDriverSettings);

      const sortedWorkDriver = workDriverSettings
        ?.slice()
        ?.sort((a, b) => a.display - b.display);

      const visibleRows = sortedWorkDriver?.filter(
        (item) => item.display !== 0
      );
      const hiddenRows = sortedWorkDriver?.filter((item) => item.display === 0);

      const allZero = visibleRows?.length === 0;

      if (allZero) {
        setVisibleWorkDriverRows(sortedWorkDriver);
      } else {
        setVisibleWorkDriverRows(visibleRows);
      }
      setHiddenWorkDriverRows(hiddenRows);
      setAllZeroWorkDriver(allZero);
    }

    // Trends Graph Settings
    if (trendsGraphSettings) {
      setTrendsFormControl(trendsGraphSettings);

      const sortedTrends = trendsGraphSettings
        ?.slice()
        ?.sort((a, b) => a.display_on_trends - b.display_on_trends);

      const visibleRows = sortedTrends?.filter(
        (item) => item.display_on_trends !== 0
      );
      const hiddenRows = sortedTrends?.filter(
        (item) => item.display_on_trends === 0
      );

      const allZero = visibleRows?.length === 0;

      if (allZero) {
        setVisibleTrendsRows(sortedTrends);
      } else {
        setVisibleTrendsRows(visibleRows);
      }
      setHiddenTrendsRows(hiddenRows);
      setAllZeroTrends(allZero);
    }

    setISInitialData(true);
  };

  useEffect(() => {
    getInitalData();
  }, []);

  const onSubmit = (values, onSubmittingProps) => {
    console.log("form Values", values);
    formSubmit(values);
    // setTimeout(() => {
    //   onSubmittingProps.setSubmitting(false);
    // }, [2000]);
  };
  const formSubmit = async (values) => {

    const trendsFormlength = trendsFormControl.length + 1;

    const trendsUpdatedData = await Promise.resolve(
      trendsFormControl.map((item) => {
        if (item.display_on_trends > 0) {
          return {
            ...item,
            custom_display_on_trends: -(
              trendsFormlength - item.display_on_trends
            ),
          };
        }
        return item;
      })
    );

    const obj = {
      customer_code: parseInt(customer_code),
      cost_center_category_id: values.cost_center_category_id,
      cost_center_category: values.cost_center_category,
      note: values.note,
      workdriver_control: formControl,
      trends_control: trendsUpdatedData,
    };
    try {
      setIsLoading(true);
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/costcentercategory/addUpdate`,
        obj
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      navigate("/admin/realtime-cost-center-categories");
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // **************Workdriver Graph settings********************* 
  const handleDragEndPatientVisible = (result) => {
    if (!result.destination) return;
  
    const items = Array.from(visibleWorkDriverRows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
  
    const updatedVisibleRows = items.map((item, index) => ({
      ...item,
      display: item.display === 0 ? 0 : index + 1,
      display_on_trends: item.display_on_trends === 0 ? 0 : index + 1,
    }));
  
    setVisibleWorkDriverRows(updatedVisibleRows);
  
    setFormControl((prevFormControl) => {
      const updatedPatientData = prevFormControl?.map((item) => {
        const matchedVisibleItem = updatedVisibleRows.find(
          (visibleItem) => visibleItem?._id === item?._id
        );
  
        if (matchedVisibleItem) {
          return {
            ...item,
            display: matchedVisibleItem.display,
            // display_on_trends: matchedVisibleItem.display_on_trends,
          };
        }
  
        return item;
      });
      return updatedPatientData;
    });
  };
  
  const handleCheckboxPatient = (fieldName, isChecked) => {
  
    setFormControl((prevFormControl) => {
      const visibleRows = prevFormControl?.filter((item) => item.display !== 0);
  
      if (isChecked && visibleRows.length >= 4) {
        showErrorToast("Only 4 items can have 'Workdriver Graph' set to Yes.");
        return prevFormControl;
      }
  
      const updatedPatientData = prevFormControl?.map((item) =>
        item.field_name === fieldName
          ? {
              ...item,
              display: isChecked ? visibleRows.length + 1 : 0, // update display
              required: isChecked ? 0 : 0,
              display_graph: isChecked ? 0 : 0,
              display_on_trends: isChecked ? item.display_on_trends : 0,
            }
          : item
      );
      return updatedPatientData;
    });
  
    setVisibleWorkDriverRows((prevVisibleRows) => {
      const visibleRowsP = formControl?.filter((item) => item.display !== 0);
  
      if (isChecked && visibleRowsP?.length >= 4) {
        return prevVisibleRows;
      }
  
      const updatedVisiblePatientData = prevVisibleRows?.map((item) =>
        item?.field_name === fieldName
          ? {
              ...item,
              display: isChecked ? visibleRowsP?.length + 1 : 0,
              required: 0,
              display_graph: 0,
              display_on_trends: isChecked ? item.display_on_trends : 0,
            }
          : item
      );
  
      return updatedVisiblePatientData;
    });
  };
  
  
  
  
  const handleCheckboxwWorkdriverTrends = (fieldName, isChecked, workDriverSorting) => {
  
    const selectedPatient = formControl?.find(
      (item) => item.field_name === fieldName
    );
  
  
  
    if (!selectedPatient || selectedPatient.display === 0) {
      showErrorToast("Please select 'Workdriver Graph' first before selecting 'Trends Graph'.");
      return; // block selection
    }
  
    setFormControl((prevFormControl) => {
      const visibleRows = prevFormControl?.filter((item) => item.display_on_trends !== 0);
      
      const updatedPatientData = prevFormControl?.map((item) =>
        item.field_name === fieldName
          ? {
              ...item,
              display_on_trends: isChecked ? workDriverSorting : 0,
            }
          : item
      );
      return updatedPatientData;
    });
  
    const visibleRowsP = formControl?.filter((item) => item.display_on_trends !== 0);
  
    const updatedVisiblePatientData = visibleWorkDriverRows?.map((item) =>
      item?.field_name === fieldName
        ? {
            ...item,
            display_on_trends: isChecked ? workDriverSorting : 0,
          }
        : item
    );
  
    setVisibleWorkDriverRows(updatedVisiblePatientData);
  };
  
  const handlePatientLabel = (fieldName, val) => {
    setFormControl((prevFormControl) => {
      const fieldExists = prevFormControl?.some(
        (item) => item.field_name === fieldName
      );
  
      let updatedPatientData;
      if (fieldExists) {
        updatedPatientData = prevFormControl?.map((item) => {
          if (item.field_name === fieldName) {
            return { ...item, field_label: val };
          }
          return item;
        });
      } else {
        updatedPatientData = [
          ...prevFormControl,
          {
            field_name: fieldName,
            field_label: val,
            display: 0,
            required: 0,
          },
        ];
      }
  
      return updatedPatientData;
    });
  };
  
  
  const toggleShowMorePatient = () => {
    setShowAllWorkDriver((prevShowAll) => {
      const sortedWorkDriver = formControl
        ?.slice()
        ?.sort((a, b) => a.display - b.display);
  
      const visibleRows = sortedWorkDriver?.filter((item) => item.display !== 0);
      const hiddenRows = sortedWorkDriver?.filter((item) => item.display === 0);
  
      if (!prevShowAll) {
        setVisibleWorkDriverRows([...visibleRows, ...hiddenRows]);
      } else {
        setVisibleWorkDriverRows(visibleRows);
      }
  
      return !prevShowAll;
    });
  };
  
  
  // **************Trends Graph settings********************* 
  
  const handleDragEndTrendsVisible = (result) => {
    if (!result.destination) return;
  
    const items = Array.from(visibleTrendsRows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
  
    const updatedVisibleRows = items.map((item, index) => ({
      ...item,
      display_on_trends: item.display_on_trends === 0 ? 0 : index + 1,
    }));
  
    setVisibleTrendsRows(updatedVisibleRows);
  
    setTrendsFormControl((prevFormControl) => {
      const updatedPatientData = prevFormControl?.map((item) => {
        const matchedVisibleItem = updatedVisibleRows.find(
          (visibleItem) => visibleItem?._id === item?._id
        );
  
        if (matchedVisibleItem) {
          return {
            ...item,
            display_on_trends: matchedVisibleItem.display_on_trends,
          };
        }
  
        return item;
      });
      return updatedPatientData;
    });
  };
  
  const handleCheckboxTrends = (fieldName, isChecked) => {
    setTrendsFormControl((prevFormControl) => {
      const visibleRows = prevFormControl?.filter((item) => item.display_on_trends !== 0);
  
      const updatedPatientData = prevFormControl?.map((item) =>
        item.field_name === fieldName
          ? {
              ...item,
              display_on_trends: isChecked ? visibleRows.length + 1 : 0, // update display
              required: isChecked ? 0 : 0,
              display_graph: isChecked ? 0 : 0,
            }
          : item
      );
      return updatedPatientData;
    });
  
    const visibleRowsP = trendsFormControl?.filter((item) => item.display_on_trends !== 0);
  
    const updatedVisiblePatientData = visibleTrendsRows?.map((item) =>
      item?.field_name === fieldName
        ? {
            ...item,
            display_on_trends: isChecked ? visibleRowsP?.length + 1 : 0, // update display
            required: isChecked ? 0 : 0,
            display_graph: isChecked ? 0 : 0,
          }
        : item
    );
  
    setVisibleTrendsRows(updatedVisiblePatientData);
  };
  
  const handleTrendsLabel = (fieldName, val) => {
    setTrendsFormControl((prevFormControl) => {
      const fieldExists = prevFormControl?.some(
        (item) => item.field_name === fieldName
      );
  
      let updatedPatientData;
      if (fieldExists) {
        updatedPatientData = prevFormControl?.map((item) => {
          if (item.field_name === fieldName) {
            return { ...item, field_label: val };
          }
          return item;
        });
      } else {
        updatedPatientData = [
          ...prevFormControl,
          {
            field_name: fieldName,
            field_label: val,
            display_on_trends: 0,
            required: 0,
          },
        ];
      }
  
      return updatedPatientData;
    });
  };
  
  const toggleShowMoreTrends = () => {
    setShowAllTrends((prevShowAll) => {
      const sortedTrends = trendsFormControl
        ?.slice()
        ?.sort((a, b) => a.display_on_trends - b.display_on_trends);
  
      const visibleRows = sortedTrends?.filter((item) => item.display_on_trends !== 0);
      const hiddenRows = sortedTrends?.filter((item) => item.display_on_trends === 0);
  
      if (!prevShowAll) {
        setVisibleTrendsRows([...visibleRows, ...hiddenRows]);
      } else {
        setVisibleTrendsRows(visibleRows);
      }
  
      return !prevShowAll;
    });
  };
  
    function debounce(func, wait) {
      let timeout;
  
      return function executedFunction(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func(...args);
        }, wait);
      };
    }
  
    const showErrorToast = debounce((message) => {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }, 500);
  

  return (
    <>
      {isInitialData ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validate={CostCenterCategoryValidation}
          enableReinitialize
          validateOnChange
        >
          {(formik) => (
            <div className="main-panel">
              {console.log(formik)}
              <div className="content-wrapper">
                <div className="page-header">
                  <h3 className="page-title">
                    <a href="#" className="badge badge-dark"></a>
                  </h3>
                  <div className></div>
                </div>
                <div className="row">
                  <div class="col-12 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <div className="d-flex justify-content-between">
                          <Link
                            to={`/admin/realtime-cost-center-categories`}
                            className="f-14 white-text-dark-mode"
                          >
                            <FontAwesomeIcon icon="fa-solid fa-arrow-left " />{" "}
                            Back
                          </Link>
                          <h4 class="card-title">Add RealTime Cost Center Category</h4>
                          <div></div>
                        </div>

                        <FormikForm className="forms-sample">
                          <div class="row">
                            <Form.Group
                              className="col-md-6 mb-3"
                              controlId="exampleForm.c_code"
                            >
                              <Form.Label>Category Id</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder=""
                                name="cost_center_category_id"
                                {...formik.getFieldProps(
                                  "cost_center_category_id"
                                )}
                              />
                              <ErrorMessage
                                name="cost_center_category_id"
                                component={Texterror}
                              />
                            </Form.Group>
                            <Form.Group
                              className="col-md-6 mb-3"
                              controlId="exampleForm.c_name"
                            >
                              <Form.Label>Category Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder=""
                                name="cost_center_category"
                                {...formik.getFieldProps(
                                  "cost_center_category"
                                )}
                              />
                              <ErrorMessage
                                name="cost_center_category"
                                component={Texterror}
                              />
                            </Form.Group>
                            <Form.Group
                              className="col-md-12 mb-3"
                              controlId="exampleForm.c_name"
                            >
                              <Form.Label>Note</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder=""
                                name="note"
                                {...formik.getFieldProps("note")}
                              />
                              <ErrorMessage name="note" component={Texterror} />
                            </Form.Group>
                           <div className="row mt-2">
                                                        <div class="col-12 grid-margin stretch-card">
                                                          <div class="card">
                                                            <div class="card-body py-4">
                                                              <div className="d-flex justify-content-between">
                                                                <div className="d-flex">
                                                                  <h4 class="card-title fs-5 mb-0">
                                                                    Workdriver/Trends Graphs
                                                                  </h4>
                                                                </div>
                                                              </div>
                          
                                                              <div class="row">
                                                                <div className="col-md-12 m-0">
                                                                  <hr />
                                                                </div>
                                                                <div className="col-md-12">
                                                                  <DragDropContext
                                                                    onDragEnd={
                                                                      handleDragEndPatientVisible
                                                                    }
                                                                  >
                                                                    <Droppable droppableId="visible-data-table">
                                                                      {(provided) => (
                                                                        <table
                                                                          className="table"
                                                                          {...provided.droppableProps}
                                                                          ref={provided.innerRef}
                                                                          style={{
                                                                            tableLayout: "fixed",
                                                                            width: "100%",
                                                                          }}
                                                                        >
                                                                          <thead>
                                                                            <tr>
                                                                              <th
                                                                                style={{ width: "5%" }}
                                                                              ></th>
                                                                              <th
                                                                                style={{ width: "10%" }}
                                                                              >
                                                                                Workdriver Graph
                                                                              </th>
                                                                              <th
                                                                                style={{ width: "10%" }}
                                                                              >
                                                                                Trends Graph
                                                                              </th>
                                                                              <th
                                                                                style={{ width: "10%" }}
                                                                              >
                                                                                Notes
                                                                              </th>
                                                                              <th
                                                                                style={{ width: "30%" }}
                                                                              >
                                                                                Key
                                                                              </th>
                                                                              <th
                                                                                style={{ width: "35%" }}
                                                                              >
                                                                                Label
                                                                              </th>
                                                                            </tr>
                                                                          </thead>
                                                                          <tbody>
                                                                            {visibleWorkDriverRows?.map(
                                                                              (val, ind) => {
                                                                                const foundPatientData =
                                                                                  formControl?.find(
                                                                                    (e) =>
                                                                                      e?.field_name ===
                                                                                      val?.field_name
                                                                                  );
                                                                                return (
                                                                                  <Draggable
                                                                                    key={
                                                                                      val?._id
                                                                                    }
                                                                                    draggableId={
                                                                                      val?._id
                                                                                    }
                                                                                    index={
                                                                                      ind
                                                                                    }
                                                                                  >
                                                                                    {(
                                                                                      provided,
                                                                                      snapshot
                                                                                    ) => (
                                                                                      <tr
                                                                                        key={
                                                                                          ind
                                                                                        }
                                                                                        ref={
                                                                                          provided.innerRef
                                                                                        }
                                                                                        {...provided.draggableProps}
                                                                                        className={`drag-row ${
                                                                                          snapshot.isDragging
                                                                                            ? "dragging"
                                                                                            : ""
                                                                                        }`}
                                                                                        style={{
                                                                                          ...provided
                                                                                            .draggableProps
                                                                                            .style,
                                                                                          boxShadow:
                                                                                            snapshot.isDragging
                                                                                              ? "0 4px 8px rgba(0, 0, 0, 0.2)"
                                                                                              : "none",
                                                                                          tableLayout:
                                                                                            "fixed",
                                                                                        }}
                                                                                      >
                                                                                        <td
                                                                                          style={{
                                                                                            width:
                                                                                              "5%",
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src={
                                                                                              themeMode.theme ===
                                                                                              "DARK"
                                                                                                ? dragDark
                                                                                                : dragWhite
                                                                                            }
                                                                                            alt=""
                                                                                            {...provided.dragHandleProps}
                                                                                            style={{
                                                                                              width:
                                                                                                "15px",
                                                                                              height:
                                                                                                "auto",
                                                                                              cursor:
                                                                                                "grab",
                                                                                            }}
                                                                                          />
                                                                                        </td>
                                                                                        <td
                                                                                          style={{
                                                                                            width:
                                                                                              "10%",
                                                                                          }}
                                                                                          className="sm-transparent-input"
                                                                                          key={
                                                                                            ind
                                                                                          }
                                                                                        >
                                                                                          <div className="checkbox-item">
                                                                                            <input
                                                                                              type="checkbox"
                                                                                              checked={
                                                                                                foundPatientData?.display >
                                                                                                0
                                                                                              }
                                                                                              onChange={(
                                                                                                e
                                                                                              ) =>
                                                                                                handleCheckboxPatient(
                                                                                                  foundPatientData.field_name,
                                                                                                  e
                                                                                                    .target
                                                                                                    .checked
                                                                                                )
                                                                                              }
                                                                                              className="custom-checkbox"
                                                                                              id={`checkbox-${foundPatientData?._id}`}
                                                                                            />
                                                                                          </div>
                                                                                        </td>
                                                                                        {val?.display_on_trends_checkbox ? (
                                                                                          <td
                                                                                            style={{
                                                                                              width:
                                                                                                "10%",
                                                                                            }}
                                                                                            className="sm-transparent-input"
                                                                                            key={
                                                                                              ind
                                                                                            }
                                                                                          >
                                                                                            <div className="checkbox-item">
                                                                                              <input
                                                                                                type="checkbox"
                                                                                                checked={
                                                                                                  foundPatientData?.display_on_trends >
                                                                                                  0
                                                                                                }
                                                                                                onChange={(
                                                                                                  e
                                                                                                ) =>
                                                                                                  handleCheckboxwWorkdriverTrends(
                                                                                                    foundPatientData.field_name,
                                                                                                    e
                                                                                                      .target
                                                                                                      .checked,
                                                                                                    foundPatientData?.display
                                                                                                  )
                                                                                                }
                                                                                                className="custom-checkbox"
                                                                                                id={`checkbox-${foundPatientData?._id}`}
                                                                                              />
                                                                                            </div>
                                                                                          </td>
                                                                                        ) : (
                                                                                          <td
                                                                                            style={{
                                                                                              width:
                                                                                                "10%",
                                                                                            }}
                                                                                          ></td>
                                                                                        )}
                                                                                        {val?.notes ? (
                                                                                          <td
                                                                                            style={{
                                                                                              width:
                                                                                                "10%",
                                                                                              height:
                                                                                                "30px",
                                                                                              textAlign:
                                                                                                "left",
                                                                                              lineHeight:
                                                                                                "35px",
                                                                                            }}
                                                                                          >
                                                                                            <OverlayTrigger
                                                                                              key="top"
                                                                                              placement="top"
                                                                                              overlay={
                                                                                                <Tooltip
                                                                                                  id={`tooltip-top`}
                                                                                                >
                                                                                                  <strong>
                                                                                                    Formula:
                                                                                                  </strong>{" "}
                                                                                                  {
                                                                                                    val?.notes
                                                                                                  }
                                                                                                </Tooltip>
                                                                                              }
                                                                                            >
                                                                                              <img
                                                                                                src={
                                                                                                  calcIcon
                                                                                                }
                                                                                                alt=""
                                                                                                style={{
                                                                                                  width:
                                                                                                    "36px",
                                                                                                  height:
                                                                                                    "auto",
                                                                                                  cursor:
                                                                                                    "pointer",
                                                                                                }}
                                                                                              />
                                                                                            </OverlayTrigger>
                                                                                          </td>
                                                                                        ) : (
                                                                                          <td
                                                                                            style={{
                                                                                              width:
                                                                                                "10%",
                                                                                            }}
                                                                                          ></td>
                                                                                        )}
                                                                                        <td
                                                                                          style={{
                                                                                            width:
                                                                                              "30%",
                                                                                          }}
                                                                                          className="pe-5"
                                                                                        >
                                                                                          <div className="d-flex align-items-center">
                                                                                            <input
                                                                                              type="text"
                                                                                              className="form-control mx-w-340"
                                                                                              value={
                                                                                                val?.field_name
                                                                                              }
                                                                                              readOnly
                                                                                            />
                                                                                          </div>
                                                                                        </td>
                                                                                        <td
                                                                                          style={{
                                                                                            width:
                                                                                              "35%",
                                                                                          }}
                                                                                          className="pe-5"
                                                                                        >
                                                                                          <div className="d-flex align-items-center">
                                                                                            <input
                                                                                              type="text"
                                                                                              className="form-control mx-w-340"
                                                                                              value={
                                                                                                foundPatientData?.field_label
                                                                                              }
                                                                                              onChange={(
                                                                                                e
                                                                                              ) => {
                                                                                                handlePatientLabel(
                                                                                                  val?.field_name,
                                                                                                  e
                                                                                                    .target
                                                                                                    .value
                                                                                                );
                                                                                              }}
                                                                                            />
                                                                                          </div>
                                                                                        </td>
                                                                                        <td></td>
                                                                                      </tr>
                                                                                    )}
                                                                                  </Draggable>
                                                                                );
                                                                              }
                                                                            )}
                                                                            {provided.placeholder}
                                                                          </tbody>
                                                                          {!allZeroWorkDriver &&
                                                                            hiddenWorkDriverRows?.length >
                                                                              0 && (
                                                                              <tfoot>
                                                                                <tr>
                                                                                  <td
                                                                                    colSpan="8"
                                                                                    className="text-center"
                                                                                  >
                                                                                    <button
                                                                                      type="button"
                                                                                      onClick={
                                                                                        toggleShowMorePatient
                                                                                      }
                                                                                      className="btn btn-success"
                                                                                    >
                                                                                      {showAllWorkDriver
                                                                                        ? "Show Less"
                                                                                        : "Show More"}
                                                                                    </button>
                                                                                  </td>
                                                                                </tr>
                                                                              </tfoot>
                                                                            )}
                                                                        </table>
                                                                      )}
                                                                    </Droppable>
                                                                  </DragDropContext>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                            </div>

                            <div className="row mt-2">
                              <div class="col-12 grid-margin stretch-card">
                                <div class="card">
                                  <div class="card-body py-4">
                                    <div className="d-flex justify-content-between">
                                      <div className="d-flex">
                                        <h4 class="card-title fs-5 mb-0">
                                          Trends Graphs
                                        </h4>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div className="col-md-12 m-0">
                                        <hr />
                                      </div>
                                      <div className="col-md-12">
                                        <DragDropContext
                                          onDragEnd={handleDragEndTrendsVisible}
                                        >
                                          <Droppable droppableId="visible-data-table">
                                            {(provided) => (
                                              <table
                                                className="table"
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{
                                                  tableLayout: "fixed",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th
                                                      style={{ width: "5%" }}
                                                    ></th>
                                                    <th
                                                      style={{ width: "10%" }}
                                                    >
                                                      Show/Hide
                                                    </th>
                                                    <th
                                                      style={{ width: "10%" }}
                                                    >
                                                      Notes
                                                    </th>
                                                    <th
                                                      style={{ width: "35%" }}
                                                    >
                                                      Key
                                                    </th>
                                                    <th
                                                      style={{ width: "40%" }}
                                                    >
                                                      Label
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {visibleTrendsRows?.map(
                                                    (val, ind) => {
                                                      const foundPatientData =
                                                        trendsFormControl?.find(
                                                          (e) =>
                                                            e?.field_name ===
                                                            val?.field_name
                                                        );
                                                      return (
                                                        <Draggable
                                                          key={val?._id}
                                                          draggableId={val?._id}
                                                          index={ind}
                                                        >
                                                          {(
                                                            provided,
                                                            snapshot
                                                          ) => (
                                                            <tr
                                                              key={ind}
                                                              ref={
                                                                provided.innerRef
                                                              }
                                                              {...provided.draggableProps}
                                                              className={`drag-row ${
                                                                snapshot.isDragging
                                                                  ? "dragging"
                                                                  : ""
                                                              }`}
                                                              style={{
                                                                ...provided
                                                                  .draggableProps
                                                                  .style,
                                                                boxShadow:
                                                                  snapshot.isDragging
                                                                    ? "0 4px 8px rgba(0, 0, 0, 0.2)"
                                                                    : "none",
                                                                tableLayout:
                                                                  "fixed",
                                                              }}
                                                            >
                                                              <td
                                                                style={{
                                                                  width: "5%",
                                                                }}
                                                              >
                                                                <img
                                                                  src={
                                                                    themeMode.theme ===
                                                                    "DARK"
                                                                      ? dragDark
                                                                      : dragWhite
                                                                  }
                                                                  alt=""
                                                                  {...provided.dragHandleProps}
                                                                  style={{
                                                                    width:
                                                                      "15px",
                                                                    height:
                                                                      "auto",
                                                                    cursor:
                                                                      "grab",
                                                                  }}
                                                                />
                                                              </td>
                                                              <td
                                                                style={{
                                                                  width: "10%",
                                                                }}
                                                                className="sm-transparent-input"
                                                                key={ind}
                                                              >
                                                                <div className="checkbox-item">
                                                                  <input
                                                                    type="checkbox"
                                                                    checked={
                                                                      foundPatientData?.display_on_trends >
                                                                      0
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      handleCheckboxTrends(
                                                                        foundPatientData.field_name,
                                                                        e.target
                                                                          .checked
                                                                      )
                                                                    }
                                                                    className="custom-checkbox"
                                                                    id={`checkbox-${foundPatientData?._id}`}
                                                                  />
                                                                </div>
                                                              </td>
                                                              {val?.notes ? (
                                                                <td
                                                                  style={{
                                                                    width:
                                                                      "10%",
                                                                    height:
                                                                      "30px",
                                                                    textAlign:
                                                                      "left",
                                                                    lineHeight:
                                                                      "35px",
                                                                  }}
                                                                >
                                                                  <OverlayTrigger
                                                                    key="top"
                                                                    placement="top"
                                                                    overlay={
                                                                      <Tooltip
                                                                        id={`tooltip-top`}
                                                                      >
                                                                        <strong>
                                                                          Formula:
                                                                        </strong>{" "}
                                                                        {
                                                                          val?.notes
                                                                        }
                                                                      </Tooltip>
                                                                    }
                                                                  >
                                                                    <img
                                                                      src={
                                                                        calcIcon
                                                                      }
                                                                      alt=""
                                                                      style={{
                                                                        width:
                                                                          "36px",
                                                                        height:
                                                                          "auto",
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                    />
                                                                  </OverlayTrigger>
                                                                </td>
                                                              ) : (
                                                                <td
                                                                  style={{
                                                                    width:
                                                                      "10%",
                                                                  }}
                                                                ></td>
                                                              )}
                                                              <td
                                                                style={{
                                                                  width: "35%",
                                                                }}
                                                                className="pe-5"
                                                              >
                                                                <div className="d-flex align-items-center">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control mx-w-340"
                                                                    value={
                                                                      val?.field_name
                                                                    }
                                                                    readOnly
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  width: "40%",
                                                                }}
                                                                className="pe-5"
                                                              >
                                                                <div className="d-flex align-items-center">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control mx-w-340"
                                                                    value={
                                                                      foundPatientData?.field_label
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      handleTrendsLabel(
                                                                        val?.field_name,
                                                                        e.target
                                                                          .value
                                                                      );
                                                                    }}
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td></td>
                                                            </tr>
                                                          )}
                                                        </Draggable>
                                                      );
                                                    }
                                                  )}
                                                  {provided.placeholder}
                                                </tbody>
                                                {!allZeroTrends &&
                                                  hiddenTrendsRows?.length >
                                                    0 && (
                                                    <tfoot>
                                                      <tr>
                                                        <td
                                                          colSpan="8"
                                                          className="text-center"
                                                        >
                                                          <button
                                                            type="button"
                                                            onClick={
                                                              toggleShowMoreTrends
                                                            }
                                                            className="btn btn-success"
                                                          >
                                                            {showAllTrends
                                                              ? "Show Less"
                                                              : "Show More"}
                                                          </button>
                                                        </td>
                                                      </tr>
                                                    </tfoot>
                                                  )}
                                              </table>
                                            )}
                                          </Droppable>
                                        </DragDropContext>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Form.Group className="col-md-12 mb-3 d-flex justify-content-end">
                              {/* <Button
                              variant="primary"
                              type="button"
                              onClick={() => {
                                formik.resetForm();
                                setSelectedImage(null);
                                // const fileInput =
                                //   document.getElementById("logo");
                                // if (fileInput) {
                                //   fileInput.value = "";
                                // }
                              }}
                            >
                              Reset
                            </Button> */}
                              <Button
                                className="ms-3"
                                variant="success"
                                type="submit"
                                disabled={isLoading}
                              >
                                {isLoading ? "Saving..." : "Save"}
                              </Button>
                            </Form.Group>
                          </div>
                        </FormikForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Formik>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100vw h-100vh">
          <span class="loader" style={{ width: "50px", height: "50px" }}></span>
        </div>
      )}
    </>
  );
}

export default AddCostCenterCategory;
